import { render, staticRenderFns } from "./PerviewNode.vue?vue&type=template&id=8a80465e&scoped=true&"
import script from "./PerviewNode.vue?vue&type=script&lang=js&"
export * from "./PerviewNode.vue?vue&type=script&lang=js&"
import style0 from "./PerviewNode.vue?vue&type=style&index=0&id=8a80465e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80465e",
  null
  
)

export default component.exports